<div class="modal-header">
  <h4 class="modal-title h5" translate>Import machine settings</h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form (ngSubmit)="onSave()" [formGroup]="importSettingsForm">
  <div class="modal-body">

    <h6 class="h6">1. <span translate>limit machines</span> (<span translate>optional</span>)</h6>
    <div class="form-row">
      <!-- CATEGORY -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label for="category" translate>Category</label>
          @if (isLoadingCategories) {
            <span class="fa-solid fa-spinner fa-spin ml-2"></span>
          }
          <ng-select (change)="onCategoryChanged($event)" [items]="possibleCategories"
            [ngClass]="{ 'is-invalid': submitted && f.category.errors }"
            bindLabel="name"
            bindValue="id" formControlName="category"
            id="category" name="category">
          </ng-select>
          <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.category.errors }" class="form-control"
            id="selectedCategory"
            name="selectedCategory" type="text">
          </div>
        </div>

        <!--ORGANIZATION-->
        <div class="col-12 col-lg-6">
          <div class="form-group">
            <label for="parentId" translate>Organization</label>
            @if (isLoadingOrganizations) {
              <span class="fa-solid fa-spinner fa-spin ml-2"></span>
            }
            <ng-select (change)="onOrganizationChanged($event)" [items]="possibleOrganizations"
              [ngClass]="{ 'is-invalid': submitted && f.parentId.errors }"
              bindLabel="name"
              bindValue="id" formControlName="parentId"
              id="parentId" name="parentId">
            </ng-select>
            <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.parentId.errors }" class="form-control"
              id="selectedParent"
              name="selectedParent" type="text">
            </div>
          </div>
        </div>

        <div class="divider"></div>

        <div class="form-row">
          <!-- MACHINE-->
          @if (displayGroup) {
            <div class="col-12">
              <div class="form-group">
                <label for="machineType">2. <span translate>Select Machine</span>
              </label>
              <ng-select [items]="machines" [ngClass]="{ 'is-invalid': submitted && f.machineType.errors }" bindLabel="name"
                bindValue="type" formControlName="machineType"
                id="machineType" name="machine">
              </ng-select>
              <input [hidden]="true" [ngClass]="{ 'is-invalid': submitted && f.machineType.errors }" class="form-control"
                id="selectedMachine" name="selectedMachine"
                type="text">
              </div>
            </div>
          }
        </div>

        <div class="divider"></div>

        <h6 class="h6">3. <span translate>Select Configuration</span></h6>

        <div class="form-row">
          <div class="col-12 col-lg-6">
            <div class="form-check mb-1">
              <input [(ngModel)]="copySettings.copyDataConfiguration" [ngModelOptions]="{standalone: true}"
                class="form-check-input"
                type="checkbox">
                <label class="form-check-label" translate>Data</label>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="form-check mb-1">
                <input [(ngModel)]="copySettings.copyExternalUrlConfiguration" [ngModelOptions]="{standalone: true}"
                  class="form-check-input"
                  type="checkbox">
                  <label class="form-check-label" translate>External URL</label>
                </div>
              </div>
              <div class="col-12 col-lg-6">
                <div class="form-check mb-1">
                  <input [(ngModel)]="copySettings.copyTileConfiguration" [ngModelOptions]="{standalone: true}"
                    class="form-check-input"
                    type="checkbox">
                    <label class="form-check-label" translate>Tile</label>
                  </div>
                </div>

                <div class="col-12 col-lg-6">
                  <div class="form-check mb-1">
                    <input [(ngModel)]="copySettings.copyTrafficLightConfiguration" [ngModelOptions]="{standalone: true}"
                      class="form-check-input"
                      type="checkbox">
                      <label class="form-check-label" translate>Traffic light</label>
                    </div>
                  </div>
                  <div class="col-12 col-lg-6">
                    <div class="form-check mb-1">
                      <input [(ngModel)]="copySettings.copyTableauConfiguration" [ngModelOptions]="{standalone: true}"
                        class="form-check-input"
                        type="checkbox">
                        <label class="form-check-label" translate>Tableau</label>
                      </div>
                    </div>
                    <div class="col-12 col-lg-6">
                      <div class="form-check mb-1">
                        <input [(ngModel)]="copySettings.copyStatusIndicator" [ngModelOptions]="{standalone: true}"
                          class="form-check-input"
                          type="checkbox">
                          <label class="form-check-label" translate>Status indicator</label>
                        </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <div class="form-check mb-0">
                          <input [(ngModel)]="copySettings.copyInlineFrameCockpitConfiguration" [ngModelOptions]="{standalone: true}"
                            class="form-check-input"
                            type="checkbox">
                            <label class="form-check-label" translate>Frame page</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <div class="modal-footer-inner">
                        <div class="row align-items-center flex-fill">
                          <div class="col">
                          </div>
                          <div class="col-auto">
                            <button (click)="onCancel()" class="btn btn-outline-primary mr-2" type="button">
                              <span translate>Cancel</span>
                            </button>
                            <button [disabled]="isDisabledSaveBtn" class="btn btn-primary" type="submit">
                              <span translate>Import</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
